// extracted by mini-css-extract-plugin
export default {"numericInfo":"keZD52xn"};